import { Component, OnInit, HostListener } from '@angular/core';
import { label } from 'src/app/constants/labels';

@Component({
  selector: 'app-sp-sidenav',
  templateUrl: './sp-sidenav.component.html',
  styleUrls: ['./sp-sidenav.component.scss']
})
export class SpSidenavComponent implements OnInit {
  labels;
  sideNavBar: boolean;

  constructor() {}

  ngOnInit() {
    this.labels = label;
    this.sideNavBar = false;
  }
   /**
   * on click outside close sidenav bar
   */
  @HostListener('document:click', ['$event.target']) public onDocumentClick() {
    if (this.sideNavBar) {
      this.sideNavBar = false;
    }
  }
}
